import { generateAuthHeader } from "../../commonfunctions/authentication";
import { IGetTransactions, TransactionResponseTypes } from "./types";

export default async function getTransactionsByPO(pONumber: string): Promise<IGetTransactions> {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_HALFBACK_ROOT_API}/current_customer/transactions/search_by_po_number?po_number=${pONumber}`,
      generateAuthHeader(),
    );

    const data = await res.json();

    if (res.ok && data.status === "success") {
      return {
        type: TransactionResponseTypes.SUCCESS,
        transactions: data.result?.transactions || [],
      };
    }

    // Handle error responses - return a simple, user-friendly message
    return {
      type: TransactionResponseTypes.FAIL,
      message: "No transactions found for the entered PO number.",
    };
  } catch (error) {
    return {
      type: TransactionResponseTypes.FAIL,
      message: "Failed to load Transactions",
    };
  }
}
